<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>统计与监控</el-breadcrumb-item>
      <el-breadcrumb-item>睿云服务费统计</el-breadcrumb-item>
    </el-breadcrumb>

    <el-tabs v-model="activeName" type="border-card">
      <!-- 睿云服务费统计 start -->
      <el-tab-pane label="睿云服务费统计" name="first" v-loading="tongjiloading">
        <!-- start -->
        <el-form :inline="true" :model="tongji">
          <el-form-item label="">
            <el-date-picker v-model="tongji.startYear" type="year" value-format="yyyy" placeholder="起始日期" class="mr15"></el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker v-model="tongji.endYear" type="year" value-format="yyyy" placeholder="结束日期" class="mr15"></el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="tongji.groupMode" placeholder="请选择" class="select"  style="width: 200px;">
              <el-option label="按月" value="month"></el-option>
              <el-option label="按季度" value="quarter"></el-option>
              <el-option label="按年" value="year"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clickSearchTongji">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- end -->

        <el-card class="box-card mt15">
          <div class="card_title">分润金额柱状图</div>
          <ve-histogram :data="chartData" :extend="chartExtend" :colors="chartColors"></ve-histogram>
        </el-card>

        <el-table v-loading="tongjiloading" :data="YearList" border stripe class="mt15">
          <el-table-column prop="TimeFrame" label="时间段" min-width="20px"></el-table-column>
          <el-table-column prop="MoneyIn" label="分润前总金额" min-width="40px"></el-table-column>
          <el-table-column prop="MoneyLeft" label="分润后总金额" min-width="40px"></el-table-column>
        </el-table>
      </el-tab-pane>
      <!-- 睿云服务费统计 end -->

    </el-tabs>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {

  },
  name: 'MyStatisticsRenewalOrder',
  data () {
    return {
      activeName: 'first',
      tongji: {
        startYear: '2018',
        endYear: '',
        groupMode: 'month'
      },
      tongjiloading: false,
      selectedPageNo: 1,
      YearList: [],
      chartColors: ['#ffa898', '#279673'],
      chartExtend: {
        barGap: '-100%',
        series (v) {
          v[0].barWidth = 8
          v[0].z = 1
          v[1].barWidth = 8
          v[1].z = 2
          return v
        }
      }
    }
  },
  computed: {
    chartData () {
      return {
        columns: ['TimeFrame', '分润前总金额', '分润后总金额'],
        rows: this.YearList.map(item => ({
          TimeFrame: item.TimeFrame,
          '分润前总金额': item.MoneyIn,
          '分润后总金额': item.MoneyLeft
        }))
      }
    }
  },
  mounted () {
    this.tongji.endYear = Vue.prototype.FunGetTimeStringY().toString()
    this.apiStatisticsRenewalOrder()
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
    },
    clickSearchTongji() {
      this.apiStatisticsRenewalOrder()
    },
    apiStatisticsRenewalOrder: function () {
      var that = this
      that.tongjiloading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        startYear: that.tongji.startYear,
        endYear: that.tongji.endYear,
        groupMode: that.tongji.groupMode
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_StatisticsRenewalOrder, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.YearList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.tongjiloading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.tongjiloading = false
        })
    }
  }
}
</script>

<style lang="less" scoped>
.box{
    display: flex;
}
.profit{
    display: flex;
    align-items: center;
    padding-bottom: 5px;
    margin-right: 100px;

    & li:first-child{
        width: 168px;

        & em{
            font-style: normal;
            color: #999;
            font-size: 12px;
        }
    }
    & li:last-child{
        flex: 1;

        & span{
            display: inline-block;
            padding-right: 5px;
            color: #f56c6c;
            font-size: 16px;
        }
    }
    & li.firstLi{
        width: 128px;
    }
}
</style>
